<template>
  <footer v-if="!shouldHide && this.$route.name!='Login'" class="ustom-footer bg-light border-top">
    <b-container>
      <div class="d-flex flex-row align-items-center justify-content-between">
        <div><a href="/" target="_blank">{{ $t("portalHome") }}</a></div>
        <div v-if="footerVersion" class="text-muted mb-2 text-right"  ref="footerVersion">{{ $t("footerAttribution") }}
          <br/>{{ $t("version") }}: {{ footerVersion }}</div>
      </div>
<!--      <b-row>
        <div class="col-lg-6 h-100 text-center text-lg-left my-auto ">
          <ul class="list-inline mb-2">
            <li class="list-inline-item">
              <a href="/" target="_blank">Trang chủ Portal</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <span class="text-primary cursor-pointer">Điều khoản & điều kiện</span>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <span class="text-primary cursor-pointer">Chính sách riêng tư</span>
            </li>
          </ul>
          <p class="text-muted mb-2">Sản phẩm của VNPT-IT</p>
          <p class="text-muted small mb-4 mb-lg-0">{{ displayDateTime }}</p>
        </div>
        <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul class="list-inline mb-0">
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-facebook fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-twitter-square fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="#">
                <i class="fab fa-instagram fa-2x fa-fw"></i>
              </a>
            </li>
          </ul>
        </div>
      </b-row>-->
    </b-container>
  </footer>
</template>

<style lang="scss" scoped>
  footer {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
</style>

<script lang="ts">
  import moment from "moment";
  import {Component} from "vue-property-decorator";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class Header extends BaseComponent {
    displayDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
    timeIntervalHandler = null;
    shouldHide = false;
    footerVersion = null;
    mounted() {
      // this.shouldHide = !!this.$route.meta?.hideHeaderAndFooter;
      // console.log(`Footer shouldHide`, this.shouldHide);
      //
      // this.$router.afterEach((to, from) => {
      //   this.shouldHide = !!to.meta?.hideHeaderAndFooter;
      //   console.log(`Footer shouldHide`, this.shouldHide);
      // });
      window.addEventListener('versionChange',(event:any)=> {
        if(event.detail.type != "")
        this.footerVersion = event.detail.type == 'v2' ? '2.0':'3.0';
      });
      setInterval(() => {
        this.displayDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 200);
    }

    destroyed() {
      clearInterval(this.timeIntervalHandler);
    }
  };
</script>

